import { Type } from "@angular/core";
import { InfoCardCustomCardMap } from "@tylertech/info-card-module";
import { ProjectBudgetActivityChartComponent } from './charts/projectBudgetActivityChart.component';
import { ProjectBudgetRecapChartComponent } from './charts/projectBudgetRecapChart.component';
import { ProjectSummaryChartComponent } from './charts/projectSummaryChart.component';
import { ProjectAccountHeaderCardComponent } from './components/header.card.component';
import { ProjectAccountDetailCardComponent } from './components/projectAccountDetailCard.component';
import { ProjectAccountSearchDetailComponent } from './components/projectAccountSearchDetail.component';

export * from './provider';
export * from "./charts";
export * from "./components";
export * from "./services";

export const PA_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "ProjectAccounting.ProjectBudgetActivityChart": ProjectBudgetActivityChartComponent,
    "ProjectAccounting.ProjectBudgetRecapChart": ProjectBudgetRecapChartComponent,
    "ProjectSummaryChart": ProjectSummaryChartComponent
};

/**
 * Cards for `InfoCardDialogService.showSearchDialog`. The dialog picks a card from the criteria's
 * `SearchProviderId` at runtime, so whoever opens it has to hand it this map -- pass it wherever
 * the dialog can be opened for a project accounting provider.
 */
export const PA_INFO_CARD_SEARCH_CARDS: InfoCardCustomCardMap = {
    "PAAccount.InfoCardProvider": {
        header: ProjectAccountHeaderCardComponent,
        detail: ProjectAccountDetailCardComponent
    },
    "PAAccounting.InfoCardProvider": {
        detail: ProjectAccountSearchDetailComponent
    }
};
